import { MergeLines } from '@/models/meal-counts/serving-line/merge-lines';

  export class MergeServingLineRequest {
    constructor(
      public VersionTrackingId: String,
      public MergeLines: MergeLines[]
    ) {
    }
  }
  